import { createPortal } from "react-dom";
import { usePortal } from "../../hooks/usePortal";

export const PageHeader = ({ children }: any) => {
  const target = usePortal("page-header");
  if (!target) return null;
  return createPortal(children, target);
};
